export default __webpack_public_path__ + "static/media/1.2c86c6de.jpeg";